var render, staticRenderFns
import script from "./todo_list.vue?vue&type=script&lang=js"
export * from "./todo_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41b0351c')) {
      api.createRecord('41b0351c', component.options)
    } else {
      api.reload('41b0351c', component.options)
    }
    
  }
}
component.options.__file = "found/views/homeNew/components/my_dos/todo_list.vue"
export default component.exports